/* 

  HEADS UP! THIS IS A GENERATED FILE!
  
  Changes done in this file will be overwritten on next generation from the code generator.

*/
import {
  DateRangePicker,
  NumberFilterInput,
  PipeStringFilter,
} from 'components/filters';
import {} from 'components/Selects';
import { SecureFormsy, Select } from 'flaivy-react/components/inputs';
/* eslint-enable */
import _ from 'lodash';
import PropTypes from 'prop-types';
import React, { useEffect, useState } from 'react';
import {
  Button,
  ButtonGroup,
  Col,
  FormGroup,
  Label,
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader,
  Row,
} from 'reactstrap';

// eslint-disable-next-line
async function resolveQuery(query) {
  const resolvedQuery = { ...query };
  // eslint-disable-next-line
  return resolvedQuery;
}

const defaultActionValues = () => ({});

function ArticleInInventoryFilterPanel({
  querySpecification,
  onChange,
  isSubForm,
  isModal,
  // eslint-disable-next-line
  immutableQuery,
}) {
  const [state, setState] = useState({
    querySpecification,
  });

  useEffect(() => {
    async function getResolvedQuery() {
      const fullyResolvedFilter = await resolveQuery(querySpecification || []);
      setState({
        querySpecification: {
          ...(querySpecification || defaultActionValues()),
        },
        resolvedQuery: {
          ...(fullyResolvedFilter || defaultActionValues()),
        },
      });
    }
    if (querySpecification) {
      getResolvedQuery();
    }
    /* eslint-disable-next-line */
  }, []);

  /* eslint-disable-next-line */
  const handleChange = async (key, value) => {
    const { querySpecification, resolvedQuery } = state;
    const newQuerySpecification = {
      ...querySpecification,
      [key]: _.get(value, 'id') || value,
    };
    const newResolvedQuery = { ...resolvedQuery, [key]: value };
    setState({
      querySpecification: newQuerySpecification,
      resolvedQuery: newResolvedQuery,
    });
    // eslint-disable-next-line
    await onChange(newQuerySpecification);
  };

  const reset = async () => {
    setState({
      querySpecification: { ...immutableQuery },
      resolvedQuery: {},
    });
    // eslint-disable-next-line
    await onChange({});
  };

  /* eslint-disable no-unused-vars */
  const { resolvedQuery } = state;
  /* eslint-enable */

  return (
    <>
      <SecureFormsy isSubForm={isSubForm}>
        {!isModal && (
          <Button onClick={reset} className="my-2" color="secondary" block>
            Rensa filter
          </Button>
        )}

        {typeof immutableQuery.name === 'undefined' && <FormGroup></FormGroup>}

        {typeof immutableQuery.image === 'undefined' && <FormGroup></FormGroup>}

        {typeof immutableQuery.images === 'undefined' && (
          <FormGroup></FormGroup>
        )}

        {typeof immutableQuery.productCategory === 'undefined' && (
          <FormGroup>
            <Label>Kategori / Typ / Stil</Label>
            <PipeStringFilter
              name="productCategory"
              value={_.get(resolvedQuery, 'productCategory')}
              onChange={handleChange}
            />
          </FormGroup>
        )}

        {typeof immutableQuery.shortName === 'undefined' && (
          <FormGroup></FormGroup>
        )}

        {typeof immutableQuery.articleNumber === 'undefined' && (
          <FormGroup></FormGroup>
        )}

        {typeof immutableQuery.supplierArticleNumber === 'undefined' && (
          <FormGroup></FormGroup>
        )}

        {typeof immutableQuery.supplierName === 'undefined' && (
          <FormGroup></FormGroup>
        )}

        {typeof immutableQuery.brandName === 'undefined' && (
          <FormGroup></FormGroup>
        )}

        {typeof immutableQuery.container === 'undefined' && (
          <FormGroup></FormGroup>
        )}

        {typeof immutableQuery.currency === 'undefined' && (
          <FormGroup>
            <Label>Valuta</Label>
            <Select
              instanceId="select-currency"
              name="currency"
              value={_.get(resolvedQuery, 'currency', '')}
              onChange={handleChange}
              options={[
                { value: 'SEK', label: 'SEK' },
                { value: 'NOK', label: 'NOK' },
                { value: 'DKK', label: 'DKK' },
              ]}
            />
          </FormGroup>
        )}

        {typeof immutableQuery.orderUnit === 'undefined' && (
          <FormGroup></FormGroup>
        )}

        {typeof immutableQuery.volume === 'undefined' && (
          <FormGroup>
            <Label>Volym per styck (liter)</Label>
            <NumberFilterInput
              name="volume"
              value={_.get(resolvedQuery, 'volume')}
              onChange={handleChange}
            />
          </FormGroup>
        )}

        {typeof immutableQuery.weight === 'undefined' && (
          <FormGroup>
            <Label>Vikt per styck (g)</Label>
            <NumberFilterInput
              name="weight"
              value={_.get(resolvedQuery, 'weight')}
              onChange={handleChange}
            />
          </FormGroup>
        )}

        {typeof immutableQuery.alcoholPercentage === 'undefined' && (
          <FormGroup>
            <Label>Alkoholprocent</Label>
            <NumberFilterInput
              name="alcoholPercentage"
              value={_.get(resolvedQuery, 'alcoholPercentage')}
              onChange={handleChange}
            />
          </FormGroup>
        )}

        {typeof immutableQuery.grapes === 'undefined' && (
          <FormGroup></FormGroup>
        )}

        {typeof immutableQuery.vintage === 'undefined' && (
          <FormGroup></FormGroup>
        )}

        {typeof immutableQuery.GTIN === 'undefined' && <FormGroup></FormGroup>}

        {typeof immutableQuery.active === 'undefined' && (
          <FormGroup>
            <Label>Aktiverad</Label>
            <br />
            <ButtonGroup>
              <Button
                color="secondary"
                active={_.get(resolvedQuery, 'active') === undefined}
                onClick={() => {
                  handleChange('active', undefined);
                }}
              >
                Alla
              </Button>
              <Button
                color="secondary"
                active={
                  _.get(resolvedQuery, 'active') === true ||
                  _.get(resolvedQuery, 'active') === 'true'
                }
                onClick={() => {
                  handleChange('active', true);
                }}
              >
                Ja
              </Button>
              <Button
                color="secondary"
                active={
                  _.get(resolvedQuery, 'active') === false ||
                  _.get(resolvedQuery, 'active') === 'false'
                }
                onClick={() => {
                  handleChange('active', false);
                }}
              >
                Nej
              </Button>
            </ButtonGroup>
          </FormGroup>
        )}

        {typeof immutableQuery.createdAt === 'undefined' && (
          <FormGroup>
            <Label>Skapad</Label>
            <DateRangePicker
              name="createdAt"
              value={_.get(resolvedQuery, 'createdAt')}
              onChange={handleChange}
            />
          </FormGroup>
        )}
        {typeof immutableQuery.updatedAt === 'undefined' && (
          <FormGroup>
            <Label>Uppdaterad</Label>
            <DateRangePicker
              name="updatedAt"
              value={_.get(resolvedQuery, 'updatedAt')}
              onChange={handleChange}
            />
          </FormGroup>
        )}
      </SecureFormsy>
      {isModal && (
        <Button onClick={reset} className="mt-3">
          Rensa filter
        </Button>
      )}
    </>
  );
}

ArticleInInventoryFilterPanel.propTypes = {
  querySpecification: PropTypes.object,
  immutableQuery: PropTypes.object,
  onChange: PropTypes.func.isRequired,
  isSubForm: PropTypes.bool,
  isModal: PropTypes.bool,
};

ArticleInInventoryFilterPanel.defaultProps = {
  querySpecification: defaultActionValues(),
  immutableQuery: {},
  isSubForm: false,
  isModal: false,
};

function ArticleInInventoryFilterPanelModal({
  onSubmit,
  querySpecification,
  immutableQuery,
}) {
  const [isOpen, setIsOpen] = useState(false);

  const toggle = () => {
    setIsOpen(!isOpen);
  };

  const handleChange = newQuerySpecification => {
    onSubmit(newQuerySpecification);
  };

  const applyFilters = () => {
    setIsOpen(false);
  };

  return (
    <>
      <Modal toggle={toggle} isOpen={isOpen} centered scrollable>
        <ModalHeader toggle={toggle}>Filtrera</ModalHeader>
        <ModalBody>
          <Row>
            <Col>
              <ArticleInInventoryFilterPanel
                onChange={handleChange}
                querySpecification={querySpecification}
                immutableQuery={immutableQuery}
                isModal
              />
            </Col>
          </Row>
        </ModalBody>
        <ModalFooter>
          <Row>
            <Col>
              <Button
                onClick={applyFilters}
                color="primary"
                className="float-end mt-3"
              >
                Stäng
              </Button>
            </Col>
          </Row>
        </ModalFooter>
      </Modal>
      <Button color="outline-secondary" onClick={toggle}>
        Filtrera
      </Button>
    </>
  );
}

ArticleInInventoryFilterPanelModal.propTypes = {
  onSubmit: PropTypes.func.isRequired,
  querySpecification: PropTypes.object,
  immutableQuery: PropTypes.object,
};

ArticleInInventoryFilterPanelModal.defaultProps = {
  querySpecification: null,
  immutableQuery: {},
};

module.exports = {
  ArticleInInventoryFilterPanel,
  ArticleInInventoryFilterPanelModal,
};
